const settingApiKeysCNTraditional = {
  settings_api_keys_api_docs: "更多資訊 - API",
  settings_apikeys_create_dialog_title: "創建新的 API 金鑰",
  settings_apikeys_create_dialog_desc:
    "創建一個新的 API 金鑰以便外部系統訪問您的帳戶。",
  settings_apikeys_form_name_placeholder: "輸入 API 金鑰名稱",
  settings_apikeys_form_description_placeholder: "輸入金鑰用途的簡短描述",
  settings_apikeys_form_services_placeholder: "選擇與此金鑰關聯的服務",
  settings_api_keys_api_tip:
    "如果您沒有為此新金鑰選擇任何 API，我們將假設此新金鑰為‘主金鑰’",
  settings_api_keys_api_set_master_key: "設置為主金鑰",
  "API Keys": "API 金鑰",
  API_Service: "服務",
  usage_total_this_month: "本月總調用次數：",
  usage_remaining_quota: "剩餘配額：",
  usage_reset_on: "重置於：",
  call: "次調用 | 次調用 | 次調用",
  _usage_sub_title: "使用量",
  portal_usage_sub_title: "查詢上限",
  hourly: "每小時",
  daily: "每日",
  monthly: "每月",
  usage_portal_title: "平台使用限額",
  usage_api_title: "API",
  settings_apikeys_name: "API 金鑰名稱",

  api_keys_column_query_type: "查詢類型",
  api_keys_column_auth_type: "驗證類型",
  api_keys_column_credential: "憑證",
  settings_api_logs_column_method: "方法",
  settings_api_logs_column_endpoint: "端點",
  settings_api_logs_column_status: "狀態",
  settings_api_logs_column_duration: "耗時",
  settings_api_logs_detail_request: "請求",
  settings_api_logs_detail_response: "回應",
  settings_api_logs_detail_request_id: "請求 ID",
  settings_api_keys_click_here_more_info: "點此瞭解更多資訊",
  settings_api_keys_title: "API 金鑰",
  settings_api_keys_desc:
    "API 金鑰設定頁面可安全地建立、編輯及限制 API 金鑰。使用者可指派名稱、設定使用限制並管理權限，以有效控管存取。",
  settings_api_keys_generated_by: "建立者",
  api_key: "API 金鑰",
  logs: "日誌",

  new_api_key: "新增 API 金鑰",
  dashboard: "儀表板",
  settings_api_dashboard_empty_title: "尚無 API 活動",
  settings_api_dashboard_empty_desc:
    "當您的整合開始進行呼叫後，此儀表板將顯示每日點數消耗、請求數量以及按金鑰和端點的明細。",
  settings_api_dashboard_empty_cta: "查看快速入門",
  settings_api_dashboard_chart_title: "每日使用情況",
  settings_api_dashboard_chart_metric_credits: "點數",
  settings_api_dashboard_chart_metric_calls: "呼叫次數",
  settings_api_dashboard_chart_no_data: "此區間內無使用記錄",
  settings_api_dashboard_chart_others: "其他",
  settings_api_dashboard_chart_last_refreshed: "最近更新 {time}",
  settings_api_dashboard_kpi_total_credits: "總點數",
  settings_api_dashboard_kpi_credits_pending: "等待後端支援",
  settings_api_dashboard_kpi_total_calls: "總呼叫次數",
  settings_api_dashboard_kpi_avg_per_day: "日均",
  settings_api_dashboard_kpi_avg_per_day_short: "日",
  settings_api_dashboard_kpi_range_days: "最近 {days} 天",
  settings_api_dashboard_kpi_top_endpoint: "最常用端點",
  settings_api_dashboard_kpi_top_key: "最常用 API 金鑰",
  settings_api_dashboard_filter_date_label: "日期範圍",
  settings_api_dashboard_filter_keys_label: "API 金鑰",
  settings_api_dashboard_filter_keys_placeholder: "全部 API 金鑰",
  settings_api_dashboard_filter_log_types_label: "日誌類型",
  settings_api_dashboard_filter_log_types_placeholder: "全部日誌類型",
  settings_api_dashboard_preset_7d: "最近 7 天",
  settings_api_dashboard_preset_30d: "最近 30 天",
  settings_api_dashboard_preset_90d: "最近 90 天",
  settings_api_dashboard_preset_custom: "自訂",
  settings_api_dashboard_table_by_key: "依 API 金鑰",
  settings_api_dashboard_table_by_endpoint: "依查詢類型",
  settings_api_dashboard_table_col_name: "名稱",
  settings_api_dashboard_table_col_endpoint: "查詢類型",
  settings_api_dashboard_table_col_calls: "呼叫次數",
  settings_api_dashboard_table_col_credits: "點數",
  settings_api_dashboard_table_col_cost_per_call: "每次呼叫消耗",
  settings_api_dashboard_table_col_percent: "佔比",
  settings_api_dashboard_table_empty: "此區間內無呼叫",
  settings_api_dashboard_truncated_banner:
    "僅顯示此區間最近 5,000 筆請求。縮小日期範圍以查看完整資料。",
  settings_api_dashboard_provisional_note:
    "後端儀表板端點尚未部署 —— 目前資料透過 /api_keys/logs 彙整。/api_keys/usage/daily 上線後將顯示點數消耗。",

  log_type_label_people_search: "用戶檢索",
  log_type_label_people_select_search: "用戶選擇檢索",
  log_type_label_people_search_preview: "用戶檢索預覽",
  log_type_label_people_similar_search: "相似用戶檢索",
  log_type_label_people_similar_search_preview: "相似用戶檢索預覽",
  log_type_label_people_details: "用戶詳情",
  log_type_label_people_redeem: "兌換用戶資訊",
  log_type_label_people_email_redeem: "兌換郵箱",
  log_type_label_people_phone_redeem: "兌換電話",
  log_type_label_people_lookup_reveal: "用戶查找揭示",
  log_type_label_people_contact_lookup: "用戶聯絡方式查找",
  log_type_label_people_enrichment: "用戶資料增強",
  log_type_label_people_export: "用戶匯出",
  log_type_label_people_linkedin_lookup: "用戶 LinkedIn 查找",
  log_type_label_email_validation: "郵箱驗證",
  log_type_label_company_search: "公司檢索",
  log_type_label_company_select_search: "公司選擇檢索",
  log_type_label_company_search_preview: "公司檢索預覽",
  log_type_label_company_similar_search: "相似公司檢索",
  log_type_label_company_similar_search_preview: "相似公司檢索預覽",
  log_type_label_company_trending_search: "公司趨勢檢索",
  log_type_label_company_details: "公司詳情",
  log_type_label_company_news: "公司新聞檢索",
  log_type_label_company_jobs: "公司職位檢索",
  log_type_label_company_enrichment: "公司資料增強",
  log_type_label_company_export: "公司匯出",
  log_type_label_company_linkedin_lookup: "公司 LinkedIn 查找",
  log_type_label_company_technology_lookup: "公司技術棧查找",
  log_type_label_company_lookup_similar: "公司相似查找",
  log_type_label_news_search: "新聞檢索",
  log_type_label_news_search_preview: "新聞檢索預覽",
  log_type_label_job_search: "職位檢索",
  log_type_label_job_search_preview: "職位檢索預覽",
  log_type_label_advertisement_lookup: "廣告查找",
  log_type_label_advertisement_search: "廣告檢索",
  log_type_label_advertisement_search_preview: "廣告檢索預覽",
  log_type_label_ai_translation: "AI 翻譯",
  log_type_label_monitor_trigger: "監控觸發",
  log_type_label_general: "通用",
};
export default settingApiKeysCNTraditional;

export const settingApiKeysJapanese = {
  settings_api_keys_api_docs: "詳細情報 - API",
  settings_apikeys_create_dialog_title: "新しいAPIキーの作成",
  settings_apikeys_create_dialog_desc:
    "外部システムがあなたのアカウントにアクセスするための新しいAPIキーを作成します。",
  settings_apikeys_form_name_placeholder: "APIキー名を入力",
  settings_apikeys_form_description_placeholder: "キーの用途について簡単に説明",
  settings_apikeys_form_services_placeholder: "このキーに関連付けるサービスを選択",
  settings_api_keys_api_tip:
    "この新しいキーにAPIを選択しない場合、このキーは「マスターキー」として扱われます",
  settings_api_keys_api_set_master_key: "マスターキーに設定",
  "API Keys": "APIキー",
  API_Service: "サービス",
  usage_total_this_month: "今月の総呼び出し回数：",
  usage_remaining_quota: "残りクォータ：",
  usage_reset_on: "リセット日：",
  call: "回の呼び出し | 回の呼び出し | 回の呼び出し",
  _usage_sub_title: "使用量",
  portal_usage_sub_title: "クエリ上限",
  hourly: "毎時",
  daily: "毎日",
  monthly: "毎月",
  usage_portal_title: "プラットフォーム使用制限",
  usage_api_title: "API",
  settings_apikeys_name: "APIキー名",

  api_keys_column_query_type: "クエリタイプ",
  api_keys_column_auth_type: "認証タイプ",
  api_keys_column_credential: "認証情報",
  settings_api_logs_column_method: "メソッド",
  settings_api_logs_column_endpoint: "エンドポイント",
  settings_api_logs_column_status: "ステータス",
  settings_api_logs_column_duration: "所要時間",
  settings_api_logs_detail_request: "リクエスト",
  settings_api_logs_detail_response: "レスポンス",
  settings_api_logs_detail_request_id: "リクエスト ID",
  settings_api_keys_click_here_more_info: "詳細はこちら",
  settings_api_keys_title: "APIキー",
  settings_api_keys_desc:
    "APIキー設定ページでは、安全にAPIキーを作成、編集、制限できます。ユーザーは名前を割り当て、使用制限を設定し、アクセスを効果的に管理するために権限を管理できます。",
  api_key: "APIキー",
  logs: "ログ",

  new_api_key: "新しいAPIキー",
  dashboard: "ダッシュボード",
  settings_api_dashboard_empty_title: "まだAPI利用がありません",
  settings_api_dashboard_empty_desc:
    "連携によるAPI呼び出しが始まると、このダッシュボードに毎日のクレジット消費、リクエスト数、キーとエンドポイント別の内訳が表示されます。",
  settings_api_dashboard_empty_cta: "クイックスタートを表示",
  settings_api_dashboard_chart_title: "日次利用状況",
  settings_api_dashboard_chart_metric_credits: "クレジット",
  settings_api_dashboard_chart_metric_calls: "コール数",
  settings_api_dashboard_chart_no_data: "この期間に利用はありません",
  settings_api_dashboard_chart_others: "その他",
  settings_api_dashboard_chart_last_refreshed: "最終更新 {time}",
  settings_api_dashboard_kpi_total_credits: "合計クレジット",
  settings_api_dashboard_kpi_credits_pending: "バックエンド準備中",
  settings_api_dashboard_kpi_total_calls: "合計コール数",
  settings_api_dashboard_kpi_avg_per_day: "日平均",
  settings_api_dashboard_kpi_avg_per_day_short: "日",
  settings_api_dashboard_kpi_range_days: "過去 {days} 日間",
  settings_api_dashboard_kpi_top_endpoint: "最頻エンドポイント",
  settings_api_dashboard_kpi_top_key: "最頻APIキー",
  settings_api_dashboard_filter_date_label: "期間",
  settings_api_dashboard_filter_keys_label: "APIキー",
  settings_api_dashboard_filter_keys_placeholder: "すべてのAPIキー",
  settings_api_dashboard_filter_log_types_label: "ログタイプ",
  settings_api_dashboard_filter_log_types_placeholder: "すべてのログタイプ",
  settings_api_dashboard_preset_7d: "過去 7 日間",
  settings_api_dashboard_preset_30d: "過去 30 日間",
  settings_api_dashboard_preset_90d: "過去 90 日間",
  settings_api_dashboard_preset_custom: "カスタム",
  settings_api_dashboard_table_by_key: "APIキー別",
  settings_api_dashboard_table_by_endpoint: "クエリタイプ別",
  settings_api_dashboard_table_col_name: "名前",
  settings_api_dashboard_table_col_endpoint: "クエリタイプ",
  settings_api_dashboard_table_col_calls: "コール数",
  settings_api_dashboard_table_col_credits: "クレジット",
  settings_api_dashboard_table_col_cost_per_call: "1コールあたり",
  settings_api_dashboard_table_col_percent: "割合",
  settings_api_dashboard_table_empty: "この期間にコールはありません",
  settings_api_dashboard_truncated_banner:
    "この期間の最新 5,000 件のリクエストのみを表示しています。完全なデータを表示するには期間を絞り込んでください。",
  settings_api_dashboard_provisional_note:
    "ダッシュボード用バックエンドエンドポイントは未デプロイです。現在は /api_keys/logs を集約して表示しています。/api_keys/usage/daily が公開され次第、クレジット消費が表示されます。"
};

export const settingApiKeysKorean = {
  settings_api_keys_api_docs: "추가 정보 - API",
  settings_apikeys_create_dialog_title: "새 API 키 생성",
  settings_apikeys_create_dialog_desc:
    "외부 시스템이 귀하의 계정에 접근할 수 있도록 새 API 키를 생성합니다.",
  settings_apikeys_form_name_placeholder: "API 키 이름 입력",
  settings_apikeys_form_description_placeholder: "키 용도에 대한 간단한 설명 입력",
  settings_apikeys_form_services_placeholder: "이 키와 연결할 서비스 선택",
  settings_api_keys_api_tip:
    "이 새 키에 대해 API를 선택하지 않으면 이 키는 '마스터 키'로 간주됩니다",
  settings_api_keys_api_set_master_key: "마스터 키로 설정",
  "API Keys": "API 키",
  API_Service: "서비스",
  usage_total_this_month: "이번 달 총 호출 횟수：",
  usage_remaining_quota: "남은 할당량：",
  usage_reset_on: "재설정 일자：",
  call: "회 호출 | 회 호출 | 회 호출",
  _usage_sub_title: "사용량",
  portal_usage_sub_title: "쿼리 한도",
  hourly: "매시간",
  daily: "매일",
  monthly: "매월",
  usage_portal_title: "플랫폼 사용 한도",
  usage_api_title: "API",
  settings_apikeys_name: "API 키 이름",

  api_keys_column_query_type: "쿼리 유형",
  api_keys_column_auth_type: "인증 유형",
  api_keys_column_credential: "인증 정보",
  settings_api_logs_column_method: "메서드",
  settings_api_logs_column_endpoint: "엔드포인트",
  settings_api_logs_column_status: "상태",
  settings_api_logs_column_duration: "소요 시간",
  settings_api_logs_detail_request: "요청",
  settings_api_logs_detail_response: "응답",
  settings_api_logs_detail_request_id: "요청 ID",
  settings_api_keys_click_here_more_info: "더 알아보기",
  settings_api_keys_title: "API 키",
  settings_api_keys_desc:
    "API 키 설정 페이지에서는 안전하게 API 키를 생성, 편집 및 제한할 수 있습니다. 사용자는 이름을 지정, 사용 제한을 설정하고 액세스를 효과적으로 관리하기 위해 권한을 관리할 수 있습니다.",
  api_key: "API 키",
  logs: "로그",

  new_api_key: "새 API 키",
  dashboard: "대시보드",
  settings_api_dashboard_empty_title: "아직 API 활동이 없습니다",
  settings_api_dashboard_empty_desc:
    "통합이 호출을 시작하면 이 대시보드에 일별 크레딧 소비, 요청 수, 키 및 엔드포인트별 세부 내역이 표시됩니다.",
  settings_api_dashboard_empty_cta: "빠른 시작 보기",
  settings_api_dashboard_chart_title: "일별 사용량",
  settings_api_dashboard_chart_metric_credits: "크레딧",
  settings_api_dashboard_chart_metric_calls: "호출 수",
  settings_api_dashboard_chart_no_data: "이 기간에 사용량이 없습니다",
  settings_api_dashboard_chart_others: "기타",
  settings_api_dashboard_chart_last_refreshed: "최근 갱신 {time}",
  settings_api_dashboard_kpi_total_credits: "총 크레딧",
  settings_api_dashboard_kpi_credits_pending: "백엔드 대기 중",
  settings_api_dashboard_kpi_total_calls: "총 호출 수",
  settings_api_dashboard_kpi_avg_per_day: "일평균",
  settings_api_dashboard_kpi_avg_per_day_short: "일",
  settings_api_dashboard_kpi_range_days: "최근 {days}일",
  settings_api_dashboard_kpi_top_endpoint: "최다 엔드포인트",
  settings_api_dashboard_kpi_top_key: "최다 API 키",
  settings_api_dashboard_filter_date_label: "날짜 범위",
  settings_api_dashboard_filter_keys_label: "API 키",
  settings_api_dashboard_filter_keys_placeholder: "모든 API 키",
  settings_api_dashboard_filter_log_types_label: "로그 유형",
  settings_api_dashboard_filter_log_types_placeholder: "모든 로그 유형",
  settings_api_dashboard_preset_7d: "최근 7일",
  settings_api_dashboard_preset_30d: "최근 30일",
  settings_api_dashboard_preset_90d: "최근 90일",
  settings_api_dashboard_preset_custom: "사용자 지정",
  settings_api_dashboard_table_by_key: "API 키별",
  settings_api_dashboard_table_by_endpoint: "쿼리 유형별",
  settings_api_dashboard_table_col_name: "이름",
  settings_api_dashboard_table_col_endpoint: "쿼리 유형",
  settings_api_dashboard_table_col_calls: "호출 수",
  settings_api_dashboard_table_col_credits: "크레딧",
  settings_api_dashboard_table_col_cost_per_call: "호출당",
  settings_api_dashboard_table_col_percent: "비율",
  settings_api_dashboard_table_empty: "이 기간에 호출이 없습니다",
  settings_api_dashboard_truncated_banner:
    "이 기간의 최근 5,000개 요청만 표시됩니다. 전체 데이터를 보려면 날짜 범위를 좁히세요.",
  settings_api_dashboard_provisional_note:
    "백엔드 대시보드 엔드포인트가 아직 배포되지 않았습니다. 현재 데이터는 /api_keys/logs에서 집계되며, /api_keys/usage/daily가 활성화되면 크레딧 비용이 표시됩니다."
};

export const settingApiKeysHindi = {
  settings_api_keys_api_docs: "अधिक जानकारी - API",
  settings_apikeys_create_dialog_title: "नई API कुंजी बनाएं",
  settings_apikeys_create_dialog_desc:
    "बाहरी सिस्टम को आपके अकाउंट तक पहुंचने के लिए एक नई API कुंजी बनाएं।",
  settings_apikeys_form_name_placeholder: "API कुंजी नाम दर्ज करें",
  settings_apikeys_form_description_placeholder: "कुंजी के उद्देश्य का संक्षिप्त विवरण",
  settings_apikeys_form_services_placeholder: "इस कुंजी से जुड़ी सेवाएं चुनें",
  settings_api_keys_api_tip:
    "यदि आप इस नई कुंजी के लिए कोई API नहीं चुनते हैं, तो हम इस नई कुंजी को 'मास्टर कुंजी' मानेंगे",
  settings_api_keys_api_set_master_key: "मास्टर कुंजी सेट करें",
  "API Keys": "API कुंजियाँ",
  API_Service: "सेवा",
  usage_total_this_month: "इस महीने कुल कॉल:",
  usage_remaining_quota: "शेष कोटा:",
  usage_reset_on: "रीसेट तिथि:",
  call: " कॉल |  कॉल |  कॉल",
  _usage_sub_title: "उपयोग",
  portal_usage_sub_title: "क्वेरी सीमा",
  hourly: "प्रति घंटा",
  daily: "दैनिक",
  monthly: "मासिक",
  usage_portal_title: "प्लेटफॉर्म उपयोग सीमा",
  usage_api_title: "API",
  settings_apikeys_name: "API कुंजी नाम",

  api_keys_column_query_type: "क्वेरी प्रकार",
  api_keys_column_auth_type: "प्रमाणीकरण प्रकार",
  api_keys_column_credential: "क्रेडेंशियल",
  settings_api_logs_column_method: "मेथड",
  settings_api_logs_column_endpoint: "एंडपॉइंट",
  settings_api_logs_column_status: "स्थिति",
  settings_api_logs_column_duration: "अवधि",
  settings_api_logs_detail_request: "अनुरोध",
  settings_api_logs_detail_response: "प्रतिक्रिया",
  settings_api_logs_detail_request_id: "अनुरोध ID",
  settings_api_keys_click_here_more_info: "अधिक जानकारी के लिए यहां क्लिक करें",
  settings_api_keys_title: "API कुंजियाँ",
  settings_api_keys_desc:
    "API कुंजी सेटिंग पेज सुरक्षित रूप से API कुंजियाँ बनाने, संपादित करने और सीमित करने की अनुमति देता है। उपयोगकर्ता नाम निर्दिष्ट कर सकते हैं, उपयोग सीमाएँ सेट कर सकते हैं और पहुंच को प्रभावी ढंग से प्रबंधित करने के लिए अनुमतियाँ प्रबंधित कर सकते हैं।",
  api_key: "API कुंजी",
  logs: "लॉग",

  new_api_key: "नई API कुंजी",
  dashboard: "डैशबोर्ड",
  settings_api_dashboard_empty_title: "अभी तक कोई API गतिविधि नहीं",
  settings_api_dashboard_empty_desc:
    "जब आपका एकीकरण कॉल करना शुरू करेगा, यह डैशबोर्ड दैनिक क्रेडिट खपत, अनुरोध गिनती और कुंजी व एंडपॉइंट के अनुसार विवरण दिखाएगा।",
  settings_api_dashboard_empty_cta: "क्विकस्टार्ट देखें",
  settings_api_dashboard_chart_title: "दैनिक उपयोग",
  settings_api_dashboard_chart_metric_credits: "क्रेडिट",
  settings_api_dashboard_chart_metric_calls: "कॉल",
  settings_api_dashboard_chart_no_data: "इस अवधि में कोई उपयोग नहीं",
  settings_api_dashboard_chart_others: "अन्य",
  settings_api_dashboard_chart_last_refreshed: "अंतिम बार ताज़ा {time}",
  settings_api_dashboard_kpi_total_credits: "कुल क्रेडिट",
  settings_api_dashboard_kpi_credits_pending: "बैकएंड लंबित",
  settings_api_dashboard_kpi_total_calls: "कुल कॉल",
  settings_api_dashboard_kpi_avg_per_day: "औसत / दिन",
  settings_api_dashboard_kpi_avg_per_day_short: "दिन",
  settings_api_dashboard_kpi_range_days: "पिछले {days} दिन",
  settings_api_dashboard_kpi_top_endpoint: "शीर्ष एंडपॉइंट",
  settings_api_dashboard_kpi_top_key: "शीर्ष API कुंजी",
  settings_api_dashboard_filter_date_label: "तिथि सीमा",
  settings_api_dashboard_filter_keys_label: "API कुंजी",
  settings_api_dashboard_filter_keys_placeholder: "सभी API कुंजियाँ",
  settings_api_dashboard_filter_log_types_label: "लॉग प्रकार",
  settings_api_dashboard_filter_log_types_placeholder: "सभी लॉग प्रकार",
  settings_api_dashboard_preset_7d: "पिछले 7 दिन",
  settings_api_dashboard_preset_30d: "पिछले 30 दिन",
  settings_api_dashboard_preset_90d: "पिछले 90 दिन",
  settings_api_dashboard_preset_custom: "अनुकूलित",
  settings_api_dashboard_table_by_key: "API कुंजी अनुसार",
  settings_api_dashboard_table_by_endpoint: "क्वेरी प्रकार अनुसार",
  settings_api_dashboard_table_col_name: "नाम",
  settings_api_dashboard_table_col_endpoint: "क्वेरी प्रकार",
  settings_api_dashboard_table_col_calls: "कॉल",
  settings_api_dashboard_table_col_credits: "क्रेडिट",
  settings_api_dashboard_table_col_cost_per_call: "प्रति कॉल लागत",
  settings_api_dashboard_table_col_percent: "कुल का %",
  settings_api_dashboard_table_empty: "इस अवधि में कोई कॉल नहीं",
  settings_api_dashboard_truncated_banner:
    "इस अवधि के केवल नवीनतम 5,000 अनुरोध दिखाए जा रहे हैं। पूरी जानकारी के लिए तिथि सीमा को संकीर्ण करें।",
  settings_api_dashboard_provisional_note:
    "बैकएंड डैशबोर्ड एंडपॉइंट अभी तैनात नहीं हैं — फिलहाल /api_keys/logs से एकत्रित कॉल काउंट दिखाए जा रहे हैं। /api_keys/usage/daily लाइव होने पर क्रेडिट लागत दिखेगी।"
};